import { render, staticRenderFns } from "./TiersAjout.vue?vue&type=template&id=08067b0e&"
import script from "./TiersAjout.vue?vue&type=script&lang=js&"
export * from "./TiersAjout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports